import React from "react";
import { connect } from "react-redux";
import { logIn } from "../../actions/index";

//import { GoogleLogin } from 'react-google-login'
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GoogleLogin } from '@react-oauth/google';

import history from '../../history'

import "./userLogin.css";
import gmassLogo from '../../assets/images/gmass-logo-auth.png'


export class UserLogin extends React.Component {

  constructor(props) {
    super(props)

    if (this.props.auth.tokenId) {
      history.push('/campaign')
    }

  }

  handleFailure = (result) => {
    console.log(result)
    alert(result)
  }
  handleLogin = (googleData) => {
    console.log(googleData)
    this.props.logIn(googleData.credential)
      .then((response) => {
        console.log(response)
        if (response === 'success') {
          history.push('/campaign')
        } else {
          console.log('Something went wrong with the login, please try again')
        }
      })

  }


  render() {
    return (
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>

        <div className="UserLogin" data-test="UserLoginComponent">
          <img src={gmassLogo} alt="Login" className="UserLogin-image-1" />
          <h1> GMass Support Dashboard </h1>
          <div>

            {/* <GoogleLogin 
          clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
          buttonText="Log in with Google"
          onSuccess={this.handleLogin}
          onFailure={this.handleFailure}
          cookiePolicy={'single_host_origin'}
          hostedDomain={'wordzen.com'}
          ></GoogleLogin>
         */}
            <GoogleLogin
              onSuccess={this.handleLogin}
              onError={this.handleFailure}
            />

          </div>
        </div>

      </GoogleOAuthProvider>

    );
  }
}


const mapStateToProps = (state) => {
  return { auth: state.auth };
};

export default connect(mapStateToProps, { logIn })(UserLogin);
